import React, { ReactElement } from 'react'

export const Layout1x1: React.FC = (): ReactElement => (
    <div className='layout-1x1'>
        <svg viewBox='0 0 30 30'>
            <g>
                <path className='dashboard-layout-outer-border' d='M28,2v26H2V2H28 M30,0H0v30h30V0L30,0z' />
            </g>
            <rect x='2' y='2' className='dashboard-background-1 dashboard-layout-entry-square' width='26' height='26' />
            <rect x='9' y='12' className='dashboard-layout-text-container' width='12' height='6' />
            <text
                transform='matrix(1 0 0 1 13.6385 17.6876)'
                className='dashboard-foreground-1 dashboard-layout-entry-text'
            >
                1
            </text>
        </svg>
    </div>
)
